
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/on-set",
      function () {
        return require("private-next-pages/on-set.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/on-set"])
      });
    }
  